/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Vibebids_Hours_AgoInputs */

const en_directory_vibebids_hours_ago = /** @type {(inputs: Directory_Vibebids_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} hours ago`)
};

const zh_directory_vibebids_hours_ago = /** @type {(inputs: Directory_Vibebids_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 小时前`)
};

/**
* | output |
* | --- |
* | "{count} hours ago" |
*
* @param {Directory_Vibebids_Hours_AgoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_hours_ago = /** @type {((inputs: Directory_Vibebids_Hours_AgoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Hours_AgoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_hours_ago(inputs)
	return zh_directory_vibebids_hours_ago(inputs)
});
export { directory_vibebids_hours_ago as "directory.vibebids.hours_ago" }